import DropdownActions from '@/components/table/dropdownActions';
import NoResults from '@/components/table/noResults';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import { dateFormatter } from '@/shared/utils/date';
import guid from '@/shared/utils/guid';
import { format } from 'date-fns';
import { signaturePacketTableColumns } from '../../constants';
import { WetSignatureUploadHistoryResponseDto } from '../../types';

interface TableBodyProps {
  signaturePacketTableData: WetSignatureUploadHistoryResponseDto[];
  viewSignaturePacket: (fileName: string) => Promise<void>;
}

const TableBody = ({ signaturePacketTableData, viewSignaturePacket }: TableBodyProps) => {
  if (!signaturePacketTableData?.length) {
    return <NoResults />;
  }

  return (
    <>
      {signaturePacketTableData.map((row) => (
        <TableRowWrapper key={guid()}>
          <TableRowCell width={signaturePacketTableColumns[0].width}>
            <TextCell>{row?.versionDate && dateFormatter(format(new Date(row.versionDate), 'yyyy-MM-dd'), 'yyyy-MM-dd')}</TextCell>
          </TableRowCell>
          <TableRowCell width={signaturePacketTableColumns[1].width}>
            <TextCell>{row.task}</TextCell>
          </TableRowCell>
          <TableRowCell width={signaturePacketTableColumns[2].width}>
            <TextCell>{row.completedBy}</TextCell>
          </TableRowCell>
          <TableRowCell width={signaturePacketTableColumns[3].width}>
            <TextCell>{row.email}</TextCell>
          </TableRowCell>
          <TableRowCell width={signaturePacketTableColumns[4].width}>
            <DropdownActions items={[{ name: 'View Signature Packet', onClick: () => viewSignaturePacket(row?.fileName) }]} />
          </TableRowCell>
        </TableRowWrapper>
      ))}
    </>
  );
};

export default TableBody;
